import { stripHtmlTags } from './utils'

export function getPostExcerpt(excerpt: string | undefined) {
  if (!excerpt) return ''

  // if excerpt is not provided by the author, wordpress tries to generate it
  if (excerpt.includes('class="more-link"')) return ''

  return stripHtmlTags(excerpt)
}
